export enum FeatureToggle {
  cartAssistantPromptStarters = 'rt_cart_assistant_prompt_starters',
}
